module.exports = __webpack_public_path__ + "img/reply-discussion.dc677901.svg";